import { breakpoints, Button, Dialog, Inline, Stack, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { Illustration } from '@eti/components';
import { useHistory } from 'react-router-dom';
import { constants } from '@eti/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SessionExpiredDialog = _ref => {
  let {
    brandCode,
    isOpen,
    handleButtonClick,
    unauthorizedRedirectionUrl
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    brands
  } = constants;
  const isAgencyBrand = brandCode === brands.JOURNEYDETAILS;
  const redirectToAuthenticate = () => {
    history.push(unauthorizedRedirectionUrl);
    handleButtonClick();
  };
  return /*#__PURE__*/_jsx(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": "expired-session-dialog",
    illustration: /*#__PURE__*/_jsx(Illustration, {
      brand: brandCode,
      id: "reload"
    }),
    isOpen: isOpen,
    title: t('IbeClient.ExpiredSession.Modal.Title'),
    children: /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsx(Text, {
        children: isAgencyBrand ? t('IbeClient.ExpiredSession.Modal.Agency.Description') : t('IbeClient.ExpiredSession.Modal.Description')
      }), !isAgencyBrand && /*#__PURE__*/_jsx(Inline, {
        align: "end",
        collapseBelow: breakpoints._560,
        spacing: 8,
        children: /*#__PURE__*/_jsx(Button, {
          "data-testid": "log-in-button",
          onClick: redirectToAuthenticate,
          variant: "primary",
          children: t('IbeClient.ExpiredSession.Modal.Button')
        })
      })]
    })
  });
};
export default SessionExpiredDialog;
//# sourceMappingURL=SessionExpiredDialog.js.map